@if (option(); as option) {
  <div
    class="theme-text p-2 rounded-md transition-colors flex w-full gap-2 items-center"
  >
    <app-checkbox [value]="active()" (valueChange)="handleCheck($event)" />
    <p>{{ label() }}</p>
  </div>
}
